import type { FaireProductEntity } from "../../entity_types/product";

export const p_nejve3d29q: FaireProductEntity = {
  token: "p_nejve3d29q",
  type: "product",
  name: "Burning Love Matches",
  brandToken: "b_b703e67f",
  brandName: "A Shop of Things",
  imageUrl:
    "https://cdn.faire.com/fastly/ad1da40511a89dbc79502e884b1a7f7bf4a83d8267a54b889456807046b9f8fd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87ff2d4d3c4753c1489527dcce9e468130ad9cce05e0d3c428cead9aac1f6616.jpeg",
  ],
  priceDollars: 2.08,
  description:
    '\nCute decorative matchbox filled with 18 wooden safety matches with white tips 😍\n\nSilkscreened and designed by our friend Dustin who also did our logo!\n\napprox. 18 wooden safety matches in cardboard slide out box\n\n2.25" x 1.375"\n\nmade in the USA\n\nPlease be careful when using this product and keep away from children! We can not be held liable for any accidents that occur when using this product.\n\nLighters/matches can NOT be shipped internationally.\n',
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:20.637Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
